import { render, staticRenderFns } from "./UsersBalance.vue?vue&type=template&id=e7becb38&scoped=true&"
import script from "./UsersBalance.vue?vue&type=script&lang=js&"
export * from "./UsersBalance.vue?vue&type=script&lang=js&"
import style0 from "./UsersBalance.vue?vue&type=style&index=0&id=e7becb38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7becb38",
  null
  
)

export default component.exports